module.exports = __webpack_public_path__ + "img/empty-documents.d3faa445.svg";